// extracted by mini-css-extract-plugin
module.exports = {"container":"guide_container__yBfOX","wrap":"guide_wrap__2k_VL","videoFrame":"guide_videoFrame__qSIY7"};